




















































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { OsusumeDetailService } from "@/services/OsusumeDetail.service.ts";
import Number from "@/shared/filters/Number";
import { Osusume, OsusumeItem } from "@/models/OsusumeDetail.ts";
import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import Pagination from "@/views/components/Pagination.vue";
import vuedraggable from "vuedraggable";
import DialogMasterCopy from './components/DialogMasterCopy.vue';
import FilterSelectBox from '@/shared/mixins/FilterSelectBox';
import ComponentWithGroupShaten from '@/views/components/ComponentWithGroupShaten';
/** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
import { SeibiService } from "@/services/Seibi.service";
/** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    Pagination,
    draggable: vuedraggable,
    DialogMasterCopy
  },
  mixins: [FilterSelectBox]
})
export default class OsusumeDetail extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;
  public osusumeService = new OsusumeDetailService();
  public osusumeData: OsusumeItem;
  public osusumeEdit: OsusumeItem;
  public osusumeList: OsusumeItem[] = [];
  public osusumeItemList: OsusumeItem[] = [];

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;
  private loading: boolean = false;
  public dialogFormVisible: boolean = false;
  maxOsusume: number = 10;
  // disableBtnAdd: boolean = true;
  timerReOrder: any = null;
  public showOsusume: boolean = false;
  public showFlg: any = {
    displayCoupon: 0,
    displayProposal: 0,
    displayTokuten: 0,
    displayAdditionalOptions: 0
  };

  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
  public seibiService = new SeibiService();
  shuukeiDataList: any = [];
  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */

  $refs!: {
    dialogCopy: DialogMasterCopy;
  };

  public async getShowFlag() {
    const response = await this.osusumeService.getShowFlag(this.form);
    if (response) {
      this.showFlg = response;
      this.$set(this, "showOsusume", this.showFlg.displayTokuten == 1?true:false);
    }
  }

  constructor() {
    super();

    this.osusumeData = {
      kyotenCd: "",
      tokutenNm: ""
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
      , shuukeiKbn: null
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
    };

    this.osusumeEdit = {
      kyotenCd: "",
      tokutenNm: ""
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
      , shuukeiKbn: null
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
    };
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public onSubmit() {
    if (this.osusumeData.tokutenNm) {
      this.loading = true;
      const data = {
        ...this.osusumeData,
        groupCd: this.form.groupCd,
        shatenCd: this.form.shatenCd,
        kyotenCd: this.form.kyotenCd
      };
      /** 2023-07-28 sh #8295(BQR1045) ommit shuukeiKbn. (temporary) [START] */
      delete data.shuukeiKbn;
      /** 2023-07-28 sh #8295(BQR1045) ommit shuukeiKbn. (temporary) [END] */
      this.addOsusumeItem({ ...data });
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
      this.clearOsusumeData();
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
    }
  }

  public async selectKyoten() {
    this.loading = true;
    const data = this.kyotenDataList.filter(
      (e: any) => e.staffCd === this.form.kyotenCd
    );
    this.getTokutenList();
    this.delay(1000);
  }

  public async getTokutenList(id?: number) {
    const response = await this.osusumeService.getTokuten(this.form, id);
    if (response) {
      const data = response.map((e: any) => {
        return { ...e, isEdit: false };
      });
      this.$set(this, "osusumeList", [...data]);
      this.osusumeData.tokutenNm = '';
    } else {
      this.$set(this, "osusumeList", []);
    }
    // this.checkDisabledAdd();
  }

  public async addOsusumeItem(data: OsusumeItem) {
    const response = await this.osusumeService.editOsusume(data);
    if (response) {
      this.getTokutenList();
      this.delay(1000);
    } else {
      console.log(response);
      this.delay(1000);
    }
  }

  public async delCouponItem(id: number) {
    this.loading = true;
    const response = await this.osusumeService.deleteOsusume(id);
    if (response === 200) {
      this.getTokutenList();
      this.delay(1000);
    } else {
      console.log(response);
      this.delay(1000);
    }
  }

  public showEditDialog(rowData: any) {
    this.dialogFormVisible = true;
    this.osusumeEdit = { ...rowData };
  }

  public editOsusumeItem() {
    this.loading = true;
    if (this.osusumeEdit.id && this.osusumeEdit.tokutenNm) {
      const data = {
        id: this.osusumeEdit.id,
        groupCd: this.form.groupCd,
        shatenCd: this.form.shatenCd,
        kyotenCd: this.form.kyotenCd,
        tokutenNm: this.osusumeEdit.tokutenNm
        /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
        , shuukeiKbn: this.osusumeEdit.shuukeiKbn
        /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
      };
      this.addOsusumeItem({ ...data });
    }
    this.dialogFormVisible = false;
  }

  private mounted() {
    this.getGroupDataList().then(res => {
      this.getShatenDataList().then(res2 => {
        this.getKyotenDataList().then(res3 => {
          this.getShowFlag();
          this.getTokutenList();
          /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
          this.getMExpSeibiShuukeiKbn();
          /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
        });
      });
    });
    this.form.kyotenCd = localStorage.getItem("kyotenCd");
  }

  get checkDisabledAdd() {
    let disabled = false;
    if (this.osusumeList.length >= this.maxOsusume) {
      disabled = true;
    } else if (this.osusumeData.tokutenNm === "") {
      disabled = true;
    }

    // this.$set(this, "disableBtnAdd", disabled);
    return disabled;
  }

  onEnd(event: any) {
    if (this.form.groupCd && this.form.shatenCd) {
      if (this.timerReOrder) {
        clearTimeout(this.timerReOrder);
        this.timerReOrder = null;
      }
      this.timerReOrder = setTimeout(() => {
        const data = this.osusumeList.map((e: any) => {
          let item = {
            ...e,
            groupCd: this.form.groupCd,
            shatenCd: this.form.shatenCd
          };
          delete item.isEdit;
          return item;
        });
        this.saveOsusumeList(data);
      }, 1000);
    }
  }

  public async saveOsusumeList(data: any) {
    const response = await this.osusumeService.saveOsusume(data, this.form);
    if (response) {
      console.log(response);
    }
  }

  onOpenMasterCopy() {
    this.$refs.dialogCopy.open();
  }

  public async saveShowOsusume() {
    const response = await this.osusumeService.saveShowOsusume({
      ...this.showFlg,
      displayTokuten: this.showOsusume?1:0,
      kyotenCd: this.form.kyotenCd
    });
    if (response) {
      console.log(response);
    }
  }
  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
  async getMExpSeibiShuukeiKbn() {
    const res = await this.seibiService.getMExpSeibiShuukeiKbn();
    if (res) {
      this.shuukeiDataList = res;
    } else {
      this.shuukeiDataList = [];
    }
  }

  getShuukeiKbnLabel(item: any) {
    const tempShuukei: any = this.shuukeiDataList.filter(
      (data: any) => item.shuukeiKbn != null && data.shuukeiKbn == item.shuukeiKbn
    );
    if (tempShuukei.length !== 0 && tempShuukei.length > 0) {
      return tempShuukei[0].shuukeiKbnNm;
    }

    return '';
  }

  clearOsusumeData() {
    this.osusumeData.tokutenNm = '';
    this.osusumeData.shuukeiKbn = null;
  }
  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
}
